//src/app/layout/dashboardLayout/index.tsx
import useMediaQueries from 'app/hooks/useMediaQueries';
import SideBarNav from 'Components/SideBarNav';
import { Outlet } from 'react-router';
import { Container } from './BoxLayout';

export default function DashboardLayout({
  internalPadding = true,
  wrapOutlet = true,
}: {
  internalPadding?: boolean;
  wrapOutlet?: boolean;
}) {
  const { md_down: isMobile } = useMediaQueries();
  return (
    <div
      className="relative grid grid-rows-1 max-h-full w-full rounded-t-4xl md-max:rounded-none bg-gray-400 p-6 md-max:p-0 md-max:mt-0"
      style={{
        boxShadow: '0px 10px 20px #8D8D8D14 inset',
      }}
    >
      <div className="flex gap-4 bg-gray-400 w-full h-full overflow-y-auto">
        {!isMobile && (
          <div className="w-56 rounded-3xl md-max:rounded-t-xl bg-white pr-4 pl-4 pt-7 pb-7">
            <SideBarNav />
          </div>
        )}

        <Container
          className={`${
            internalPadding ? 'py-5 px-7 md-max:py-2 md-max:px-3' : ''
          } flex-1 `}
        >
          <Outlet />
        </Container>
      </div>
    </div>
  );
}
